import * as React from "react";

/** Cases « reproduit » d'un lien avec une bibliographie, déjà normalisées. */
export type BibliographyReproductionInput = {
  coul: boolean;
  couv: boolean;
  nP: boolean;
  page: string;
  planche: string;
  plancheNonNum: boolean;
};

/**
 * Fragment « repr. » d'une référence bibliographique, commun aux CF œuvre,
 * multiple et exemplaire de multiple (sculptures et tirages passent par le CF
 * œuvre via leurs relation mappers).
 *
 * Avec la couverture : « repr. couv. » seule, « repr. couv. et p. 12 » quand la
 * reproduction est aussi à l'intérieur ; avec une planche, une planche non
 * numérotée ou « n. p. », on garde « repr. (couv., pl. 3) ». La couleur ne
 * change que le préfixe : « repr. coul. couv. ».
 */
export const renderReproductionPart = (
  {
    coul,
    couv,
    nP,
    page,
    planche,
    plancheNonNum,
  }: BibliographyReproductionInput,
  t: (key: string) => string,
): React.ReactNode => {
  const reprPrefix = coul
    ? t("computeField.reproduitCouleurAbbrege")
    : t("computeField.reproduitAbbrege");

  if (couv) {
    if (page) {
      return (
        <>
          {reprPrefix} {t("computeField.couvAbbrege")}{" "}
          {t("computeField.etConjonction")} {t("computeField.pageAbbrege")}{" "}
          {page}
        </>
      );
    }
    // repr. [coul.] (couv., ...) — second part: pl. X | pl. non num. | n. p.
    let inner: React.ReactNode = null;
    if (planche) {
      inner = (
        <>
          {t("computeField.couvAbbrege")}, {t("computeField.plancheAbbrege")}{" "}
          {planche}
        </>
      );
    } else if (plancheNonNum) {
      inner = (
        <>
          {t("computeField.couvAbbrege")},{" "}
          {t("computeField.plancheNonNumAbbrege")}
        </>
      );
    } else if (nP) {
      inner = (
        <>
          {t("computeField.couvAbbrege")}, {t("computeField.nonPagineAbbrege")}
        </>
      );
    }
    if (inner) {
      return (
        <>
          {reprPrefix} ({inner})
        </>
      );
    }
    return (
      <>
        {reprPrefix} {t("computeField.couvAbbrege")}
      </>
    );
  }

  // Sans couverture: repr. [coul.] p. X | (pl. X) | (pl. non num.) | (n. p.)
  if (page && !nP) {
    return (
      <>
        {reprPrefix} {t("computeField.pageAbbrege")} {page}
      </>
    );
  }
  if (planche) {
    return (
      <>
        {reprPrefix} ({t("computeField.plancheAbbrege")} {planche})
      </>
    );
  }
  if (plancheNonNum) {
    return (
      <>
        {reprPrefix} ({t("computeField.plancheNonNumAbbrege")})
      </>
    );
  }
  if (nP) {
    return (
      <>
        {reprPrefix} ({t("computeField.nonPagineAbbrege")})
      </>
    );
  }
  return null;
};
